import React from 'react';
import { ReactComponent as NextArrow } from '../../../assets/right_arrow.svg';
import { ReactComponent as PreviousArrow } from '../../../assets/left_arrow.svg';
import Slider from 'react-slick';
import PictureImage from '../../../utils/Image/PictureImage';
import { getImage } from '../../../utils/Functions';
import { withContent } from '../../../hoc/withContext';
import { IContent } from '../../../types';
import {
  DesktopGameSliderImageContainer,
  DesktopSliderArrowLeft,
  DesktopSliderArrowRight,
  DesktopSliderContainer
} from './DesktopSliderStyle';
import Fade from 'react-reveal/Fade';

const NextArrowContainer = (props : any) => {
  const { onClick } = props;
  return (
    <DesktopSliderArrowRight
      onClick={onClick}
    ><NextArrow/></DesktopSliderArrowRight>
  );
}

const PrevArrowContainer = (props : any) => {
  const { onClick } = props;
  return (
    <DesktopSliderArrowLeft
      onClick={onClick}
    ><PreviousArrow /></DesktopSliderArrowLeft>
  );
}

interface IGameSliderProps {
  context? : IContent;
}

const DesktopSlider = ({context} : IGameSliderProps) => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    nextArrow: <NextArrowContainer />,
    prevArrow: <PrevArrowContainer />,
    autoplay: true,
    slidesToScroll: 3,
    autoplaySpeed: 4000
  };

  return (
    <DesktopSliderContainer>
      <Slider {...settings}>
        {context.gameSlider.game.map((imageLink: string) => {
          return (
            <Fade center>
              <DesktopGameSliderImageContainer key={"slide_" + imageLink}>
                <PictureImage
                  images={getImage(imageLink + '_desktop', false)}
                  extension="png"
                  altText={imageLink}
                  className={['']}
                />
              </DesktopGameSliderImageContainer>
            </Fade>);
        })}
      </Slider>
    </DesktopSliderContainer>
  );
};

export default withContent(DesktopSlider);